const { getContacts, createContact, updateContact, deleteContact } = require('@/controllers/contacts').ct_contacts;

const initialState = () => ({
    contacts: [],
    pagination: {},
});

const state = initialState();

const mutations = {
    SET_CONTACTS(state, { data, pagination = {} }) {
        state.contacts = data;
        state.pagination = pagination;
    },
    RESET_CONTACTS_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_contacts(state) {
        return state.contacts;
    },
    get_contacts_pagination(state) {
        return state.pagination;
    },
};

const actions = {
    async load_contacts({ commit }, params = {}) {
        const response = await getContacts(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_CONTACTS', response);
        return response.data;
    },

    // autocomplete (Novo lançamento e Tabela de clientes): devolve a lista sem mexer na tela de contatos
    async search_contacts(_, params = {}) {
        const response = await getContacts({ limit: 8, ...params });

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    // payload: { id?, ...campos }
    async save_contact(_, { id, ...data }) {
        const response = id ? await updateContact(id, data) : await createContact(data);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    async remove_contact(_, id) {
        const response = await deleteContact(id);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
